import { useEffect, useMemo, useState } from "react"

import { useDispatch, useSelector } from "react-redux"

import { getDates } from "../../../../../Utils/utils"
import { getAdminTableRewardChart } from "../../../redux/referrals.thunks"
import ChartModal from "../../ChartModal/ChartModal"

const RewardChartModal = ({ open, close, baId, userId }) => {
  const dispatch = useDispatch()
  const { adminTableRewardChart, adminTableRewardChartFetching } = useSelector(
    (state) => state.referrals
  )

  const [period, setPeriod] = useState("7 days")

  const totalValue = useMemo(() => {
    return adminTableRewardChart?.result?.daily_total?.reduce((sum, cur) => sum + cur) ?? 0
  }, [adminTableRewardChart])

  const formattedChartData = useMemo(() => {
    if (
      !adminTableRewardChart ||
      !adminTableRewardChart?.result ||
      !adminTableRewardChart?.result?.daily_total
    ) {
      return null
    }
    return {
      ...adminTableRewardChart,
      result: {
        ...adminTableRewardChart?.result,
        daily_total: adminTableRewardChart?.result?.daily_total?.map((value) => value / 100) || []
      }
    }
  }, [adminTableRewardChart])

  const getRewardChart = (query, baId, user_id) => {
    dispatch(
      getAdminTableRewardChart({
        params: {
          business_account_id: baId,
          user_id,
          ...query
        }
      })
    )
  }

  useEffect(() => {
    const period_query = getDates(period)
    if (baId && userId && open) {
      getRewardChart(period_query, baId, userId)
    }
  }, [open, baId, userId, period])

  return (
    <ChartModal
      open={open}
      close={close}
      data={formattedChartData}
      dataType="volume"
      title="Reward"
      loading={adminTableRewardChartFetching}
      period={period}
      setPeriod={setPeriod}
      total={totalValue}
    />
  )
}

export default RewardChartModal
